import * as Yup from 'yup';
import { descriptionRequired, nameRequired, stringRequired } from '.';

export const reminderSchema = Yup.object({
    name: nameRequired,
    date: stringRequired,
    description: descriptionRequired
});

export const addReminderSchema = Yup.object({
    title: nameRequired,
    due_date: stringRequired,
    description: descriptionRequired,
    due_time: stringRequired
});